import axios from "axios";

const ins = axios.create();
ins.interceptors.response.use(function (resp) {
  if (!resp.data.status) {
    // if (resp.data.errorcode === "4005" || resp.data.errorcode === "40051" || resp.data.errorcode === "400511") {
    //   window.location.href = "https://clubs.xinmin.cn/dzclub/index.html#/auth";
    //   return null;
    // }

    return resp.data;
  }
  return resp.data;
});

export default ins;